"use client";

import {
  defaultHolidayFormValue,
  holidaySearchSchema,
  type IHolidaySearchSchema,
} from "@/feature/holiday/search/schema/holiday-search.schema";
import type { IHolidaySearchQueryParams } from "@/feature/holiday/search/types/holiday-search-type";

const HOLIDAY_SEARCH_SESSION_KEY = "holiday:search:last:v1";

function cloneHolidaySearchData(
  data: IHolidaySearchSchema,
): IHolidaySearchSchema {
  return {
    city: data.city
      ? {
          city_id: data.city.city_id,
          city: data.city.city,
          country_name: data.city.country_name,
          lat: data.city.lat,
          lng: data.city.lng,
        }
      : null,
  };
}

export function createInitialHolidaySearchData(
  serverInitialData?: IHolidaySearchQueryParams | null,
): IHolidaySearchSchema {
  if (serverInitialData?.city_id && serverInitialData.city) {
    return {
      city: {
        city_id: Number(serverInitialData.city_id),
        city: serverInitialData.city,
        country_name: serverInitialData.country,
      },
    };
  }

  return cloneHolidaySearchData(defaultHolidayFormValue);
}

export function saveLastHolidaySearch(data: IHolidaySearchSchema): void {
  if (typeof window === "undefined") return;

  try {
    window.sessionStorage.setItem(
      HOLIDAY_SEARCH_SESSION_KEY,
      JSON.stringify(cloneHolidaySearchData(data)),
    );
  } catch {
    // Ignore sessionStorage failures.
  }
}

export function getLastHolidaySearch(): IHolidaySearchSchema | null {
  if (typeof window === "undefined") return null;

  try {
    const raw = window.sessionStorage.getItem(HOLIDAY_SEARCH_SESSION_KEY);
    if (!raw) return null;

    const parsed = JSON.parse(raw) as IHolidaySearchSchema;
    const result = holidaySearchSchema.safeParse(parsed);

    if (!result.success) {
      window.sessionStorage.removeItem(HOLIDAY_SEARCH_SESSION_KEY);
      return null;
    }

    return cloneHolidaySearchData(result.data);
  } catch {
    window.sessionStorage.removeItem(HOLIDAY_SEARCH_SESSION_KEY);
    return null;
  }
}
